/**
 * Tracks select_item event when a native product card is clicked
 */
window.onGtmReady(function() {
  const PRODUCT_CARD_SELECTOR = 'product-card[data-gtm-product-id]';

  const attachClickHandler = (productCard) => {
    if (productCard.dataset.gtmClickAttached === 'true') return;
    
    productCard.addEventListener('click', function(e) {
      if (!e.target.closest('a')) return;

      const listName = window.gtmConfig?.listName || window.location.pathname;
      const listId = window.gtmConfig?.listId || '';

      const gtmItemData = extractGtmDataFromNativeCard(productCard);
      if (!gtmItemData) return;

      const allCards = document.querySelectorAll(PRODUCT_CARD_SELECTOR);
      const index = Array.from(allCards).indexOf(productCard) + 1;

      const item = {
        ...gtmItemData,
        index: index
      };

      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          currency: window.gtmConfig?.currency,
          item_list_id: String(listId),
          item_list_name: listName,
          items: [item]
        },
        _clear: true
      });

      console.info('✓ GTM event select_item (native) pushed to dataLayer.');
    });

    productCard.dataset.gtmClickAttached = 'true';
  };

  const attachToAllProducts = () => {
    const products = document.querySelectorAll(`${PRODUCT_CARD_SELECTOR}:not([data-gtm-click-attached="true"])`);
    products.forEach(attachClickHandler);
  };

  attachToAllProducts();

  const mutationObserver = new MutationObserver(() => {
    attachToAllProducts();
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
